( function () {
	'use strict';

	function copyTemplate ( ) {
		return {
			'templateUrl'  : '/templates/templates/copy-template/copy-template.html',
			'restrict'     : 'E',
			'replace'      : true,
			'controller'   : 'CopyTemplateCtrl',
			'controllerAs' : 'vm',
			'scope'        : {
				'templateModel' : '='
			}
		};
	}

	angular
		.module( 'app.templates' )
		.directive( 'copyTemplate', copyTemplate );
} )( );
